import { useMutation, useQueries, useQuery } from 'react-query'
import axios from 'axios'
import { AvailableAddons, OfferPackage, OfferProperty, OfferTravel, PackageItemModel, SaveOfferPackageAddonsRequest } from 'BrokerTsLib/src/dtos'
import { useUrl } from './useOffer'
import { GenericQueryOptions, longStaleTime } from 'BrokerTsLib/src/hooks'

type OfferPackageType = OfferPackage | OfferProperty | OfferTravel

const fetchOfferAvailablePackageItems = async (url: string, offerId: number) => {
    return axios.get<PackageItemModel[]>(`${url}/GetOfferAvailablePackageItems?offerId=${offerId}`)
}

export const useGetOffersAvailablePackageItems = (offersIds: number[]) => {
    const url = useUrl()

    return useQueries(
        offersIds.map((id) => ({
            queryKey: ['GetOfferAvailablePackageItems', id],
            queryFn: () => fetchOfferAvailablePackageItems(url, id),
            staleTime: longStaleTime,
            enabled: offersIds.length > 0,
            refetchOnWindowFocus: false,
        }))
    );
};

export const useGetOfferAvailablePackageItems = (offerId: number, options?: GenericQueryOptions<AvailableAddons[] | PackageItemModel[]>) => {
    const url = useUrl()
    return useQuery(['GetOfferAvailablePackageItems', offerId]
        , () => fetchOfferAvailablePackageItems(url, offerId)
        , {
            staleTime: longStaleTime,
            refetchOnWindowFocus: false,
            ...options
        })
}

export const useSaveOfferParts = () => {
    const url = useUrl()
    return useMutation({ mutationFn: (offer: OfferPackageType) => axios.post(`${url}/SaveOfferParts`, offer) })
}

export const useSaveOfferAddons = () => {
    const url = useUrl()
    return useMutation({
        mutationFn: (offer: SaveOfferPackageAddonsRequest) =>
            axios.post(`${url}/SaveOfferAddons`, offer)
    })
}